<template>
  <v-container fluid grid-list-md>
    <v-layout justify-space-between row wrap>
      <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Aviso Prévio Indenizado (em %)" 
          v-bind="currency_config"
          v-model="moduleThree.previousNoticeIndemnified"
          :hint="previousNoticeIndemnifiedValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Incidência do FGTS sobre Aviso Prévio Indenizado (em %)" 
          v-bind="currency_config"
          v-model="moduleThree.fgtsIncidencePreviousNoticeIndemnified"
          :hint="fgtsIncidencePreviousNoticeIndemnifiedValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Multa do FGTS e Contribuição Social sobre o Aviso Prévio Indenizado (em %)"
          v-model="moduleThree.fgtsPenaltyPreviousNoticeIndemnified"
          v-bind="currency_config"
          :hint="fgtsPenaltyPreviousNoticeIndemnifiedValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Aviso Prévio Trabalhado (em %)" 
          v-model="moduleThree.previousNoticeWorked"
          v-bind="currency_config"
          :hint="previousNoticeWorkedValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Incidência de GPS, FGTS e outras contribuições sobre o Aviso Prévio Trabalhado"
          v-model="moduleThree.fgtsIncidencePreviousNoticeWorked"
          v-bind="currency_config"
          :hint="fgtsIncidencePreviousNoticeWorkedValue | currency" 
          persistent-hint
        >
          
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Multa do FGTS e Contribuição Social sobre o Aviso Prévio Trabalhado (em %)"
          v-model="moduleThree.fgtsPenaltyPreviousNoticeWorked"
          v-bind="currency_config"
          :hint="fgtsPenaltyPreviousNoticeWorkedValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-btn v-if="!budgetFinalized" block color="primary" title="Adicionar Outro Encargo" @click.native.stop.prevent="addBenefit();">
          Adicionar Outro Engargo
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-layout v-for="(item, i) in moduleThree.others" :key="i">
          <v-flex :class="budgetFinalized ? 'xs12' : 'xs11'">
            <v-layout justify-start row wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Descrição" v-model="item.description" box :readonly="budgetFinalized"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="Porcentagem de Cálculo (%)"
                  title="A porcentagem digitada será multiplicada pela base de cálculo (Módulo 1 + Submódulo 2.1)"
                  v-bind="currency_config"
                  :hint="`${item.percent * calculationBasis / 100}` | currency"
                  persistent-hint
                  v-model="item.percent"
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1 v-if="!budgetFinalized">
            <v-layout align-center justify-center row fill-height>
              <v-icon class="red--text font-weight-black" title="Remover benefício" @click.stop.prevent="removeBenefit(item);">delete_forever</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <v-textarea v-model="moduleThree.notes" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

  import ModuleThreeService from '../../service/ModuleThreeService';
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
import Currency from '../../utils/Currency';

  export default {
    name: "TabModule3",

    data() {
      return {
        // CAMPOS //
        currency_config: Currency.percent,
      };
    },
    methods: {
      addBenefit() {        
        if(!this.moduleThree.others)
          this.moduleThree.others = new Array()

        this.moduleThree.others.push({
          description: "",
          percent: 0,
        });
      },
      removeBenefit(item) {
        this.moduleThree.others.splice(this.moduleThree.others.indexOf(item), 1);
      },
      async setSheetModuleThree() {
        let sheet = this.analyticalWorksheet
          if(sheet.moduleThree != this.moduleThree){
            sheet.moduleThree = Object.assign({}, this.moduleThree)
            await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
          }
      }, // setSheetModuleThree()
    }, // METHODS //

    computed: {
      amountOfModuleThree() {
        let amount =  this.fgtsIncidencePreviousNoticeIndemnifiedValue +
                      this.fgtsIncidencePreviousNoticeWorkedValue +
                      this.fgtsPenaltyPreviousNoticeIndemnifiedValue +
                      this.fgtsPenaltyPreviousNoticeWorkedValue + 
                      this.previousNoticeIndemnifiedValue +
                      this.previousNoticeWorkedValue +
                      this.othersValue
        
        this.$store.commit("SET_AMOUNT_OF_MODULE_THREE", amount);

        return amount;
      },
      calculationBasis(){
        return this.amountOfModuleOne + this.amountOfModuleTwoOne
      },
      fgtsIncidencePreviousNoticeIndemnifiedValue(){
        return ModuleThreeService.getFgtsIncidencePreviousNoticeIndemnified(this.calculationBasis, this.moduleThree)
      },
      fgtsIncidencePreviousNoticeWorkedValue(){
        return ModuleThreeService.getFgtsIncidencePreviousNoticeWorked(this.calculationBasis, this.moduleThree)
      },
      fgtsPenaltyPreviousNoticeIndemnifiedValue(){
        return ModuleThreeService.getFgtsPenaltyPreviousNoticeIndemnified(this.calculationBasis, this.moduleThree)
      },
      fgtsPenaltyPreviousNoticeWorkedValue() {
        return ModuleThreeService.getFgtsPenaltyPreviousNoticeWorked(this.calculationBasis, this.moduleThree)
      },
      informations(){
        return [
          {
            class: "xs12 md4",
            title: "Valor da Remuneração",
            subtitle: "Total do Módulo 1",
            value: this.amountOfModuleOne
          },
          {
            class: "xs12 md4",
            title: "Base de Cálculo",
            subtitle: "Módulo 1 + Submódulo 2.1",
            value: this.calculationBasis
          },
          {
            class: "xs12 md4",
            title: "Total do Módulo 3",
            subtitle: "Soma dos valores",
            value: this.amountOfModuleThree
          }
        ]
      },
      moduleThree(){
        if(this.analyticalWorksheet.moduleThree){
          return this.analyticalWorksheet.moduleThree
        }
        return SheetDefaultData.getModuleThree()
      },
      othersValue(){
        return ModuleThreeService.getOthers(this.moduleThree.others, this.calculationBasis)
      },
      previousNoticeIndemnifiedValue(){
        return ModuleThreeService.getPreviousNoticeIndemnified(this.calculationBasis, this.moduleThree)
      },
      previousNoticeWorkedValue() {
        return ModuleThreeService.getPreviousNoticeWorked(this.calculationBasis, this.moduleThree)
      },
      
      ...mapState({amountOfModuleOne            : state => state.budget.amountOfModuleOne}),
      ...mapState({amountOfModuleTwoOne         : state => state.budget.amountOfModuleTwoOne}),
      ...mapState({amountOfModuleTwoTwoPercent  : state => state.budget.amountOfModuleTwoTwoPercent}),
      ...mapState({analyticalWorksheet          : state => state.budget.analyticalWorksheet}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})

      
    }, // COMPUTED //
    watch: {
      moduleThree: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleThree()
        },
        deep: true
      },
    }
    
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/TabModule3.vue